export function markCampaignOffer(media:HTMLElement,eligible:boolean,label?:string|null):void {
 media.dataset.sfCampaignEligible=String(eligible);
 media.querySelector('.sf-campaign-badge')?.remove();
 if(!eligible||label!=='Black Friday')return;
 media.style.position='relative';
 const badge=document.createElement('span');badge.className='sf-campaign-badge';badge.textContent='BLACK FRIDAY';
 badge.style.cssText='position:absolute;left:5px;bottom:5px;z-index:2;display:inline-flex;width:max-content;max-width:calc(100% - 10px);white-space:nowrap;box-sizing:border-box;padding:3px 5px;border:1px solid #d3b56e;border-radius:4px;background:#111827;color:#ffe4a3;font:750 8px/1.2 system-ui;letter-spacing:.2px;pointer-events:none';media.append(badge);
}
export function refreshCampaignBadges(root:ShadowRoot,label?:string|null):void {
 for(const media of Array.from(root.querySelectorAll<HTMLElement>('[data-sf-campaign-eligible]')))markCampaignOffer(media,media.dataset.sfCampaignEligible==='true',label);
}
